import { CSSProperties } from 'react';
import { Link } from 'react-router-dom';
import CONSTANTS from '../../Constants';
import { useCustomPath } from '../../Hooks/use-custom-path';
import { Typography } from '../ui/Typography/Typography';
import styles from './index.module.scss';

interface GarmentCardProps {
    id: string;
    firstImageUrl: string;
    secondImageUrl: string;
    title: string;
    price: string;
    partnerId: string;
    style?: CSSProperties;
}
const GarmentCard = ({
    id,
    firstImageUrl,
    secondImageUrl,
    title,
    style,
    price,
    partnerId,
}: GarmentCardProps) => {
    const garmentDetailPath = useCustomPath({
        where: CONSTANTS.SCREEN.PRODUCT_DETAIL,
        id,
    });

    return (
        <div className={styles.card} style={style}>
            {/* TODO: Add back when partner id is returned from the API */}
            {/* <div className={styles.tryOnButton}>
                <TryOnButton
                    garments={[{ garmentId: id }]}
                    text="Try This Item"
                    variant="icon"
                    partnerId={partnerId}
                />
            </div> */}
            <Link to={garmentDetailPath}>
                <div className={styles.imageContainer}>
                    <img src={firstImageUrl} className={styles.firstImage} alt="First" />
                    <img src={secondImageUrl} className={styles.secondImage} alt="Second" />
                </div>
            </Link>
            <div className={styles.info}>
                <div>
                    <Link to={garmentDetailPath}>
                        <Typography variant="heading4" className={styles.info__title}>
                            {title.toLocaleLowerCase()}
                        </Typography>
                    </Link>
                </div>
                <Typography variant="small2" color="secondary">
                    {price}
                </Typography>
            </div>
        </div>
    );
};

export default GarmentCard;
